import { BasicCouponFragment } from 'drycut-graphql';
import { Para } from 'ui-components';

type Props = {
  couponInfo: BasicCouponFragment;
};

export default function CouponMessage({ couponInfo }: Props): React.ReactNode {
  if (!couponInfo) {
    return null;
  }

  // Only show information when we have a coupon that is a Coupons::Pass
  if (couponInfo.maxUses <= 1) {
    return null;
  }

  return (
    <Para weight="bold" size="xs" className="text-primary-600">
      Schnitt {couponInfo.bookingsCount + 1} von {couponInfo.maxUses}
    </Para>
  );
}
